import React, { useState } from 'react';
import CauseCodeListLayer from './CauseCodeListLayer';
import ExternalServicesListLayer from './ExternalServicesListLayer';
import PriorityListLayer from './PriorityListLayer';
import FailureCodeListLayer from './FailureCodeListLayer';
import TradesListLayer from './TradesListLayer';
import WorkOrderStatusLayer from './WorkOrderStatusLayer';

const tabs = [
  { key: 'cause-code', label: 'Cause Codes', Component: CauseCodeListLayer },
  { key: 'external-services', label: 'External Services', Component: ExternalServicesListLayer },
  { key: 'priority', label: 'Priority', Component: PriorityListLayer },
  { key: 'failure-code', label: 'Failure Code', Component: FailureCodeListLayer },
  { key: 'trades', label: 'Trades', Component: TradesListLayer },
  { key: 'work-order-status', label: 'Work Order Status', Component: WorkOrderStatusLayer },
];

const WorkOrderReferencesLayer = () => {
  const [activeTab, setActiveTab] = useState(tabs[0].key);
  const ActiveComponent = tabs.find(t => t.key === activeTab).Component;
  return (
    <div className='card h-100 p-0 rounded-0 overflow-hidden'>
      <div className='card-body p-0'>
        <ul className='nav nav-tabs mb-3'>
          {tabs.map(t => (
            <li key={t.key} className='nav-item'>
              <button
                className={`nav-link ${activeTab === t.key ? 'active' : ''}`}
                onClick={() => setActiveTab(t.key)}
              >
                {t.label}
              </button>
            </li>
          ))}
        </ul>
        <ActiveComponent />
      </div>
    </div>
  );
};

export default WorkOrderReferencesLayer;
